import { Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { SelectedItemsBox } from './selectionPanel/selectedItemsBox';

import { SearchBar } from '../search/searchBar';

export const AddValuesPanel = ({
  entityName,
  addedValues,
  onAddClick,
  renderItem,
  itemKey,
  onRemove,
  clearAll,
}: {
  entityName: string;
  addedValues: string[];
  onAddClick: (value: string[]) => void;
  renderItem: (item: string) => React.ReactNode;
  itemKey: (item: string) => string;
  onRemove: (item: string) => void;
  clearAll: () => void;
}) => {
  const [input, setInput] = useState('');

  return (
    <Stack className='max-h-[480px] overflow-hidden' marginTop='12px'>
      <Typography padding='12px 24px' variant='body1'>
        {`Add one or more ${entityName}${entityName.endsWith('s') ? 'es' : 's'}`}
      </Typography>
      <Stack gap='12px' divider={<Divider />} overflow='hidden'>
        <Stack padding='0 24px 12px'>
          <SearchBar
            value={input}
            setValue={setInput}
            placeholder={entityName}
            selectedValues={addedValues}
            onAddClick={onAddClick}
            showAddButton={true}
            hideSearchIcon={true}
          />
        </Stack>
        {addedValues.length > 0 && (
          <SelectedItemsBox
            items={addedValues}
            entityType={entityName}
            renderItem={renderItem}
            itemKey={itemKey}
            onRemove={onRemove}
            clearAll={clearAll}
          />
        )}
      </Stack>
    </Stack>
  );
};
